import './StatisticsCard.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
var StatisticsCard = function StatisticsCard(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("article", {
    className: "statistics-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "statistics-card__header-wrapper ".concat(props.compactHeader ? "statistics-card__header-wrapper--compact" : "")
  }, /*#__PURE__*/React.createElement(Text, {
    className: "statistics-card__value",
    tag: "div",
    field: props.value
  })), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "statistics-card__description",
    field: props.description
  })));
};
export default StatisticsCard;
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "crgwk8l";
var rtlStyles = "r1b8d7yu";
var ltrStyles = "l4lwhyt";